import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';

import App from '@app/app';

registerSW({ immediate: true });

const rootNode = document.getElementById('root');

if (!rootNode) {
  throw new Error('Root node not found');
}

createRoot(rootNode).render(<App />);
